import React from 'react';
import PropTypes from 'prop-types';

import './role-shift.less';

export function RoleShift({ role, shiftType, shiftsPerWeek, hoursPerShift }) {
  const shift = `${shiftType} - ${shiftsPerWeek}x${hoursPerShift}`;

  return (
    <div className="RoleShift">
      <div>{role}</div>
      <div>{shift}</div>
    </div>
  );
}

RoleShift.propTypes = {
  role: PropTypes.string.isRequired,
  shiftType: PropTypes.string.isRequired,
  shiftsPerWeek: PropTypes.number.isRequired,
  hoursPerShift: PropTypes.number.isRequired,
};
